import { z } from "zod";
import { createId } from "@paralleldrive/cuid2";

export const customFieldSchema = z.object({
  id: z.string().cuid2(),
  icon: z.string().describe("icon name from simpleicons"),
  name: z.string(),
  value: z.string(),
});

export const minimalCustomFieldSchema = customFieldSchema.omit({
  id: true,
});

export type CustomField = z.infer<typeof customFieldSchema>;
export type MinimalCustomField = z.infer<typeof minimalCustomFieldSchema>;

export const deminimalizeCustomFields = (customFields: MinimalCustomField[]): CustomField[] => {
  return customFields.map((customField) => ({
    ...customField,
    id: createId(),
  }));
};
